<template>
  <div id="app">
    <TokenForm /> 
    <!-- <DecryptForm /> -->
  </div>
</template>

<script>
  import TokenForm from './components/TokenForm.vue'
  // import DecryptForm from './components/DecryptForm.vue'

export default {
  name: 'App',
  components: {
    TokenForm,
    // DecryptForm
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  /* font-family: 'Microsoft YaHei', Arial, sans-serif;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px; */
}
</style>
